import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IGetGoogleAuth extends ISagaCb {
    title?: string
}
export interface IGetState {
    status: string
    data: null
    errors: any
}

const initialState: IGetState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const getGoogleAuthURL = createSlice({
    name: 'email-credential/get-google-auth-url',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IGetGoogleAuth>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const getGoogleAuthURLActions = getGoogleAuthURL.actions
export default getGoogleAuthURL.reducer
